import React, { useState, useCallback } from "react";
import styles from "./styles.module.scss";
import MessageBox from "reusableComponents/MessageBox";
import { useTranslation } from "react-i18next";

const CustomTextarea = ({
  label,
  placeholder,
  value,
  onChange,
  name,
  example,
  required = false,
  showRequiredText = false,
  error,
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const { t } = useTranslation("global");

  const stripHtmlTags = useCallback((text) => {
    if (!text) return '';
    // Create a temporary element to leverage browser's HTML parsing
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    return tempDiv.textContent || tempDiv.innerText || '';
  }, []);

  const handleChange = useCallback((e) => {
    const rawValue = e.target.value;
    const strippedValue = stripHtmlTags(rawValue);
    
    if (onChange) {
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: strippedValue,
          name: name,
        },
      };
      onChange(syntheticEvent);
    }
  }, [onChange, stripHtmlTags, name]);

  const handlePaste = useCallback((e) => {
    // Get pasted content
    const pastedText = e.clipboardData.getData('text');
    const strippedPastedText = stripHtmlTags(pastedText);
    
    // Prevent default paste
    e.preventDefault();
    
    // Insert stripped text at cursor position
    const textarea = e.target;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const currentValue = stripHtmlTags(value);
    const newValue = currentValue.substring(0, start) + strippedPastedText + currentValue.substring(end);
    
    // Trigger change with new value
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: newValue,
        name: name,
      },
    };
    onChange(syntheticEvent);
    
    // Set cursor position after paste
    setTimeout(() => {
      textarea.selectionStart = textarea.selectionEnd = start + strippedPastedText.length;
    }, 0);
  }, [stripHtmlTags, value, onChange, name]);

  const handleMouseEnter = () => setIsTooltipVisible(true);
  const handleMouseLeave = () => setIsTooltipVisible(false);

  return (
    <div className={styles.wrapper}>
      <div className={styles.textareaContainer}>
        {label && (
          <div className={styles.labelContainer}>
            <label htmlFor={name} className={styles.label}>
              {label}
              {required && (
                <span
                  className={styles.requiredIndicator}
                  style={{ fontSize: showRequiredText ? "inherit" : "18px" }}
                >
                  {showRequiredText
                    ? ` ${t("provide.step2.pictures.required")} (*)`
                    : `(*)`}
                </span>
              )}
            </label>

            <div
              className={styles.tooltipWrapper}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {example && isTooltipVisible && (
                <>
                  <span className={styles.tooltipIcon}>?</span>
                  <div
                    className={styles.tooltip}
                    dangerouslySetInnerHTML={{ __html: example }}
                  />
                </>
              )}
            </div>
          </div>
        )}
        
        <textarea
          id={name}
          name={name}
          className={styles.customTextarea}
          placeholder={placeholder}
          value={stripHtmlTags(value)}
          onChange={handleChange}
          onPaste={handlePaste}
        />
      </div>
      {error && <MessageBox type="error" message={error} />}
    </div>
  );
};

export default CustomTextarea;

// import React, { useState } from "react";
// import styles from "./styles.module.scss";
// import MessageBox from "reusableComponents/MessageBox";
// import { useTranslation } from "react-i18next";

// const CustomTextarea = ({
//   label,
//   placeholder,
//   value,
//   onChange,
//   name,
//   example,
//   required = false,
//   showRequiredText = false, // Toggle required text instead of "*"
//   error,
// }) => {
//   // State to manage tooltip visibility on hover
//   const [isTooltipVisible, setIsTooltipVisible] = useState(false);
//     const { t } = useTranslation("global");
  

//   // Handle hover
//   const handleMouseEnter = () => {
//     setIsTooltipVisible(true);
//   };

//   const handleMouseLeave = () => {
//     setIsTooltipVisible(false);
//   };

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.textareaContainer}>
//         {label && (
//           <div className={styles.labelContainer}>
//             <label htmlFor={name} className={styles.label}>
//               {label}
//               {required &&  <span
//               className={styles.requiredIndicator}
//               style={{ fontSize: showRequiredText ? "inherit" : "18px" }}
//             >
//               {showRequiredText
//                 ? ` ${t("provide.step2.pictures.required")} (*)`
//                 : `(*)`}
//             </span>}
//             </label>

//             <div
//               className={styles.tooltipWrapper}
//               onMouseEnter={handleMouseEnter}
//               onMouseLeave={handleMouseLeave}
//             >
//               {/* The question mark that triggers the tooltip on hover */}
//               {/* Show tooltip only if the 'example' prop is provided and tooltip is visible */}
//               {example && isTooltipVisible && (
//                 <>
//                   <span className={styles.tooltipIcon}>?</span>
//                   <div
//                     className={styles.tooltip}
//                     dangerouslySetInnerHTML={{ __html: example }}
//                   ></div>
//                 </>
//               )}
//             </div>
//           </div>
//         )}
//         {/* Textarea */}
//         <textarea
//           id={name}
//           name={name}
//           className={styles.customTextarea}
//           placeholder={placeholder}
//           value={value}
//           onChange={onChange}
//         />
//       </div>
//       {error && <MessageBox type="error" message={error} />}{" "}
//       {/* Using MessageBox */}
//     </div>
//   );
// };

// export default CustomTextarea;
